import React from "react";

const AppML_Prototype = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Prototype</h1>
      <p>This is the AppML Prototype page content.</p>
    </div>
  );
};

export default AppML_Prototype;
